/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AvatarMigrationChunkRequest } from '../model';
// @ts-ignore
import { AvatarMigrationIdsRequest } from '../model';
// @ts-ignore
import { AvatarMigrationResult } from '../model';
// @ts-ignore
import { AvatarMigrationSummaryDto } from '../model';
// @ts-ignore
import { AvatarRestoreResult } from '../model';
/**
 * AdminAvatarMigrationControllerApi - axios parameter creator
 * @export
 */
export const AdminAvatarMigrationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunChunk: async (avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarMigrationChunkRequest' is not null or undefined
            assertParamExists('dryRunChunk', 'avatarMigrationChunkRequest', avatarMigrationChunkRequest)
            const localVarPath = `/api/admin/technical/avatar-migration/dry-run/chunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarMigrationChunkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunIds: async (avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarMigrationIdsRequest' is not null or undefined
            assertParamExists('dryRunIds', 'avatarMigrationIdsRequest', avatarMigrationIdsRequest)
            const localVarPath = `/api/admin/technical/avatar-migration/ids/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarMigrationIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAvatarsChunk: async (avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarMigrationChunkRequest' is not null or undefined
            assertParamExists('migrateAvatarsChunk', 'avatarMigrationChunkRequest', avatarMigrationChunkRequest)
            const localVarPath = `/api/admin/technical/avatar-migration/chunk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarMigrationChunkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateIds: async (avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'avatarMigrationIdsRequest' is not null or undefined
            assertParamExists('migrateIds', 'avatarMigrationIdsRequest', avatarMigrationIdsRequest)
            const localVarPath = `/api/admin/technical/avatar-migration/ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(avatarMigrationIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview: async (limit?: number, minBytes?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/avatar-migration/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (minBytes !== undefined) {
                localVarQueryParameter['minBytes'] = minBytes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore: async (userAccountId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccountId' is not null or undefined
            assertParamExists('restore', 'userAccountId', userAccountId)
            const localVarPath = `/api/admin/technical/avatar-migration/restore/{userAccountId}`
                .replace(`{${"userAccountId"}}`, encodeURIComponent(String(userAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary: async (minBytes?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/technical/avatar-migration/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (minBytes !== undefined) {
                localVarQueryParameter['minBytes'] = minBytes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAvatarMigrationControllerApi - functional programming interface
 * @export
 */
export const AdminAvatarMigrationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAvatarMigrationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<AvatarMigrationResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunChunk(avatarMigrationChunkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<AvatarMigrationResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunIds(avatarMigrationIdsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateAvatarsChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<AvatarMigrationResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateAvatarsChunk(avatarMigrationChunkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<AvatarMigrationResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateIds(avatarMigrationIdsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preview(limit?: number, minBytes?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<AvatarMigrationResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preview(limit, minBytes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restore(userAccountId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AvatarRestoreResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restore(userAccountId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summary(minBytes?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AvatarMigrationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summary(minBytes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminAvatarMigrationControllerApi - factory interface
 * @export
 */
export const AdminAvatarMigrationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAvatarMigrationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: any): Promise<Array<AvatarMigrationResult>> {
            return localVarFp.dryRunChunk(avatarMigrationChunkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: any): Promise<Array<AvatarMigrationResult>> {
            return localVarFp.dryRunIds(avatarMigrationIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAvatarsChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: any): Promise<Array<AvatarMigrationResult>> {
            return localVarFp.migrateAvatarsChunk(avatarMigrationChunkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: any): Promise<Array<AvatarMigrationResult>> {
            return localVarFp.migrateIds(avatarMigrationIdsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview(limit?: number, minBytes?: number, options?: any): Promise<Array<AvatarMigrationResult>> {
            return localVarFp.preview(limit, minBytes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(userAccountId: number, options?: any): Promise<AvatarRestoreResult> {
            return localVarFp.restore(userAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [minBytes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary(minBytes?: number, options?: any): Promise<AvatarMigrationSummaryDto> {
            return localVarFp.summary(minBytes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAvatarMigrationControllerApi - object-oriented interface
 * @export
 * @class AdminAvatarMigrationControllerApi
 * @extends {BaseAPI}
 */
export class AdminAvatarMigrationControllerApi extends BaseAPI {
    /**
     * 
     * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public dryRunChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).dryRunChunk(avatarMigrationChunkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public dryRunIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).dryRunIds(avatarMigrationIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarMigrationChunkRequest} avatarMigrationChunkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public migrateAvatarsChunk(avatarMigrationChunkRequest: AvatarMigrationChunkRequest, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).migrateAvatarsChunk(avatarMigrationChunkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AvatarMigrationIdsRequest} avatarMigrationIdsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public migrateIds(avatarMigrationIdsRequest: AvatarMigrationIdsRequest, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).migrateIds(avatarMigrationIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [minBytes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public preview(limit?: number, minBytes?: number, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).preview(limit, minBytes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} userAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public restore(userAccountId: number, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).restore(userAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [minBytes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAvatarMigrationControllerApi
     */
    public summary(minBytes?: number, options?: AxiosRequestConfig) {
        return AdminAvatarMigrationControllerApiFp(this.configuration).summary(minBytes, options).then((request) => request(this.axios, this.basePath));
    }
}
